export default __webpack_public_path__ + "static/bnb-9d00c99aa6ae5b40a967db3a4ebd7d18.svg";